import React from 'react';
import { Carousel, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const DynamicCarousel = () => {
    const navigate = useNavigate();

    return (
        <>
            {/* All carousel styles */}
            <style>{`
                html, body {
                    overscroll-behavior: none;
                    -webkit-overflow-scrolling: touch;
                }

                .hero-carousel-section {
                    width: 100vw;
                    height: 70vh;
                    min-height: 500px;
                    max-height: 700px;
                    position: relative;
                    margin-left: calc(-50vw + 50%);
                    margin-right: calc(-50vw + 50%);
                }

                .hero-carousel-section .carousel,
                .hero-carousel-section .carousel-inner,
                .hero-carousel-section .carousel-item {
                    height: 100%;
                    width: 100%;
                }

                .hero-carousel-slide {
                    height: 100%;
                    width: 100%;
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-color: #000;
                    position: relative;
                    display: flex;
                    align-items: flex-end;
                    padding-bottom: 0.5rem;
                    justify-content: center;
                }

                .hero-carousel-overlay {
                    display: none;
                }
                // .hero-carousel-overlay {
                //     position: absolute;
                //     top: 0;
                //     left: 0;
                //     right: 0;
                //     bottom: 0;
                //     background: rgba(0, 0, 0, 0.3);
                //     z-index: 1;
                // }

                .hero-carousel-content {
                    position: relative;
                    z-index: 2;
                    text-align: center;
                    color: white;
                    max-width: 800px;
                    padding: 0 2rem;
                    padding-bottom: 2rem;
                    margin-top: auto;
                }

                .hero-carousel-title {
                    font-size: 3rem;
                    font-weight: 800;
                    letter-spacing: -0.02em;
                    margin: 0 0 1.5rem 0;
                    line-height: 1.1;
                    text-shadow: 0 2px 20px rgba(0,0,0,0.5);
                }

                .hero-carousel-subtitle {
                    font-size: 1.5rem;
                    font-weight: 300;
                    margin: 0 0 2.5rem 0;
                    opacity: 0.95;
                    text-shadow: 0 2px 10px rgba(0,0,0,0.5);
                }

                .hero-carousel-buttons {
                    display: flex;
                    gap: 1rem;
                    justify-content: center;
                    flex-wrap: wrap;
                }

                .hero-carousel-btn {
                    padding: 1rem 3rem;
                    font-size: 1.1rem;
                    font-weight: 600;
                    border: none;
                    border-radius: 25px;
                    text-decoration: none;
                    transition: all 0.2s ease;
                    cursor: pointer;
                }

                .hero-carousel-btn.btn-outline-primary {
                background: transparent;
                //border: 2px solid #FD7014;
                border: 2px solid white
                color: white;
            }
            
                .hero-carousel-btn.btn-outline-primary:hover {
                    background: #FD7014;
                    border-color: #FD7014;
                    color: white;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(253, 112, 20, 0.4);
                }
                
                .carousel-slide-blue .hero-carousel-btn.btn-outline-primary {
                    border-color: #3E6D9C;
                }
                
                .carousel-slide-blue .hero-carousel-btn.btn-outline-primary:hover {
                    background: #3E6D9C;
                    border-color: #3E6D9C;
                    box-shadow: 0 6px 20px rgba(62, 109, 156, 0.4);
                }

                .hero-carousel-btn-secondary {
                    background: transparent;
                    color: white;
                    border: 2px solid white;
                }

                .hero-carousel-btn-secondary:hover {
                    background: rgba(255, 255, 255, 0.2);
                    transform: translateY(-2px);
                }

                .hero-carousel-section .carousel-control-prev,
                .hero-carousel-section .carousel-control-next {
                    width: 5%;
                    opacity: 0.7;
                }

                .hero-carousel-section .carousel-control-prev:hover,
                .hero-carousel-section .carousel-control-next:hover {
                    opacity: 1;
                }

                .hero-carousel-section .carousel-indicators {
                    margin-bottom: 0.25rem;
                }

                .hero-carousel-section .carousel-indicators button {
                    width: 12px;
                    height: 12px;
                    border-radius: 50%;
                    margin: 0 6px;
                    background-color: white;
                }

                /* Mobile responsive */
            @media (max-width: 768px) {
                .hero-carousel-section {
                    height: auto;
                    min-height: 200px;
                    max-height: none;
                }
            
                .carousel-slide-1 .hero-carousel-slide {
                    // background-image: url(/images/Logos/Retrosmallpicture.png) !important;
                    background-image: url(/images/Logos/Slides/Mobile/Month2/1.png) !important;
                }
            
                .carousel-slide-2 .hero-carousel-slide {
                    background-image: url(/images/Logos/Slides/Mobile/Month2/2.png) !important;
                }
            
                .carousel-slide-3 .hero-carousel-slide {
                    background-image: url(/images/Logos/Slides/Mobile/Month2/3.png) !important;
                }
            
                .hero-carousel-slide {
                    background-color: transparent;
                    background-size: cover;
                    background-position: center;
                    padding-bottom: 0.25rem;
                    min-height: 250px;
                    align-items: center;
                }
            
                .hero-carousel-overlay {
                    display: none;
                }
            
                .hero-carousel-title {
                    font-size: 2.5rem;
                }
            
                .hero-carousel-subtitle {
                    font-size: 1.1rem;
                }
            
                .hero-carousel-buttons {
                    flex-direction: column;
                    width: 100%;
                }
            
                .hero-carousel-btn {
                    width: 100%;
                    padding: 0.75rem 2rem;
                    font-size: 0.75rem;
                    font-weight: 500;
                    opacity: 0.9;
                }
            }
            /* Desktop: size the banner to the slide artwork (3700×1200) so it
               fills edge to edge at every screen width — no black bars, no cropping */
            @media (min-width: 769px) {
                .hero-carousel-section {
                    height: auto;
                    aspect-ratio: 3700 / 1200;
                    min-height: 0;
                    max-height: 760px;
                }
                .hero-carousel-slide {
                    background-size: cover;
                    background-color: #3E6D9C;
                }
            }
            `}</style>

            <section className="hero-carousel-section">
                <Carousel
                    fade
                    interval={3000}
                    controls={true}
                    indicators={true}
                    pause="hover"
                >
                    <Carousel.Item className="carousel-slide-blue carousel-slide-1">
                        <div
                            className="hero-carousel-slide"
                            // style={{ backgroundImage: 'url(/images/Logos/MoviesBanner.png)' }}
                            style={{ backgroundImage: 'url(/images/Logos/Slides/Desktop/Month2/1.png)' }}
                        >
                            <div className="hero-carousel-overlay"></div>
                            <div className="hero-carousel-content">
                                <div className="hero-carousel-buttons">
                                    <Button
                                        className="hero-carousel-btn hero-carousel-btn-secondary"
                                        onClick={() => navigate('/search/?productType=Rubber%20Duck')}
                                    >
                                        Shop Now
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>

                    <Carousel.Item className="carousel-slide-orange carousel-slide-2">
                        <div
                            className="hero-carousel-slide"
                            style={{ backgroundImage: 'url(/images/Logos/Slides/Desktop/Month2/2.png)' }}
                        >
                            <div className="hero-carousel-overlay"></div>
                            <div className="hero-carousel-content">
                                <div className="hero-carousel-buttons">
                                    {/*<Button*/}
                                    {/*    variant="outline-primary"*/}
                                    {/*    className="hero-carousel-btn"*/}
                                    {/*    onClick={() => navigate('/search/Lighting')}*/}
                                    {/*>*/}
                                    {/*    Shop Now*/}
                                    {/*</Button>*/}
                                    <Button
                                        className="hero-carousel-btn hero-carousel-btn-secondary"
                                        onClick={() => navigate('/search/Lighting')}
                                    >
                                        Shop Now
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>

                    <Carousel.Item className="carousel-slide-blue carousel-slide-3">
                        <div
                            className="hero-carousel-slide"
                            // style={{ backgroundImage: 'url(/images/Logos/MugsLogo.jpg)' }}
                            style={{ backgroundImage: 'url(/images/Logos/Slides/Desktop/Month2/3.png)' }}
                        >
                            <div className="hero-carousel-overlay"></div>
                            <div className="hero-carousel-content">
                                <div className="hero-carousel-buttons">
                                    {/*<Button*/}
                                    {/*    variant="outline-primary"*/}
                                    {/*    className="hero-carousel-btn"*/}
                                    {/*    onClick={() => navigate('/search/Mugs')}*/}
                                    {/*>*/}
                                    {/*    Shop Now*/}
                                    {/*</Button>*/}
                                    <Button
                                        className="hero-carousel-btn hero-carousel-btn-secondary"
                                        onClick={() => navigate('/search/street%20fighter')}
                                    >
                                        Shop Now
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
            </section>
        </>
    );
};

export default DynamicCarousel;